import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../logo.png';

export default function Navigation() {
  return (
    <nav className="text-white shadow-lg" style={{ backgroundColor: '#16243b' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
            <img 
              src={logoImage}
              alt="Maestro Hosts" 
              className="h-8 w-auto"
            />
            <span className="text-xl font-bold hidden sm:inline">Maestrohosts</span>
          </Link>

          <div className="flex items-center gap-6">
            <Link to="/" className="hover:text-blue-100 transition-colors">Home</Link>
            <Link to="/products" className="hover:text-blue-100 transition-colors">Products</Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
